import { render } from "./data-box.vue?vue&type=template&id=0faa868c&scoped=true"
import script from "./data-box.vue?vue&type=script&lang=js"
export * from "./data-box.vue?vue&type=script&lang=js"

import "./data-box.vue?vue&type=style&index=0&id=0faa868c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0faa868c"]])

export default __exports__